import { extendTheme } from "@chakra-ui/react";

const overrides = {
    styles: {
        global: {
            body: {
                ".css-f6n2t5": {
                    minWidth: "auto",
                },
            },
        },
    },
};

export default extendTheme(overrides);
